import { API_BASE } from '../lib/apiOrigin';
import React, { useEffect, useState } from "react";
import axios from "axios";
import { BRAND_ICONS, BRAND_COLORS, GlobeIcon } from "./SocialIcons";

const API = API_BASE;

/**
 * Renders the active social-media links, ordered by display_order.
 * Uses official brand glyphs; hover flips background to the brand's
 * canonical color for that "authentic" feel while resting state stays
 * consistent with the dark footer.
 */
const SocialLinksBar = ({
  className = "",
  size = 18,
  testId = "social-links-bar",
  brandColorOnHover = true,
}) => {
  const [links, setLinks] = useState([]);
  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/social-links`)
      .then((res) => {
        if (!cancelled) setLinks(Array.isArray(res.data) ? res.data : []);
      })
      .catch(() => {
        // Public endpoint failures are non-fatal — component silently hides.
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!links.length) return null;
  return (
    <div className={`flex items-center gap-3 flex-wrap ${className}`} data-testid={testId}>
      {links.map((l) => {
        const Icon = BRAND_ICONS[l.platform] || GlobeIcon;
        const brandColor = BRAND_COLORS[l.platform];
        const isNextdoor = l.platform === "nextdoor";
        const label = isNextdoor ? "Nextdoor — Xavier Assembly" : l.label || l.platform.replace("_", " ");
        // Inline vars let each icon expose ITS OWN brand color to CSS,
        // so a single :hover rule reads it back — no per-platform classes.
        const styleVars = brandColorOnHover && brandColor
          ? { "--brand": brandColor }
          : undefined;
        return (
          <a
            key={l.id}
            data-testid={`social-link-${l.platform}`}
            href={l.url}
            target="_blank"
            rel="noreferrer"
            title={label}
            aria-label={label}
            style={styleVars}
            className={
              "social-brand-btn flex items-center justify-center " +
              (isNextdoor ? "h-11 min-w-[112px] px-3 " : "h-10 w-10 ") +
              "border border-white/15 text-white " +
              "transition-all duration-200"
            }
          >
            <Icon size={isNextdoor ? 88 : size} viewBox={isNextdoor ? "0 9.5 24 5" : undefined} className={isNextdoor ? "h-5 w-[88px]" : undefined} />
          </a>
        );
      })}
    </div>
  );
};

export default SocialLinksBar;
